import { APP_LOAD } from '@app/core/contracts/app-load';
import { StoreService } from '@b2b/features/misc/store/store.service';

export const storeProviders = [
  {
    provide: APP_LOAD,
    useExisting: StoreService,
    multi: true,
  },
];
